import { FC, Fragment } from 'react';
import clsx from 'classnames';
import { getDetail } from 'pages/vehicle-documents/components/views/utils';
import { DetailProps } from '../views.types';

import styles from './styles.module.scss';

export const FileDetails: FC<DetailProps> = props => {
  const data = getDetail(props);

  return (
    <div className={styles.container}>
      {data.map((group: any) => (
        <Fragment key={group.name}>
          <h4 className="font-semibold py-2">{group.name}</h4>
          {group.items.map((item: any, index: number) => (
            <div
              className={clsx(styles.row, 'grid grid-cols-2 h-full items-center gap-x-2 pl-4')}
              key={item.name + index}>
              <span className="py-1">{`${item.name}${item.name ? ':' : ''}`}</span>
              <span className="uppercase break-words">{item.value}</span>
            </div>
          ))}
        </Fragment>
      ))}
    </div>
  );
};
